import Left from './Left'
function ReducePrecision(props){

    return (<>
        <div style={{fontSize:'12px', width:'23px', marginLeft:'5px', fontWeight:'normal', padding:'2px', border:'0.5px solid var(--aixelo-gray-light)', borderRadius:'5px'}}>
            <div style={{margin:'0px', padding:'0px', marginLeft:'4px'}}>
                .00
            </div>
            <div style={{position:'relative', zIndex:'10', display:'flex', alignItems:'center', flexDirection:'row', fontSize:'12px', fontWeight:'normal', marginLeft:'2px'}}>
                <Left id={props.id} active={true} handleClick={props.handleClick}/> <div style={{marginLeft:'-1px', padding:'0px'}}>.0</div>
            </div>
        </div>
        </>);
}

export default ReducePrecision